"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeErrors = void 0;
exports.normalizeErrors = (errors) => {
    const errorMap = {};
    errors.forEach(err => {
        errorMap[err.path] = err.message;
    });
    return errorMap;
};
//# sourceMappingURL=normalizeErrors.js.map